import { AppState } from "../types";

const DB_NAME = "monyawn-storage";
const STORE_NAME = "state";
const DB_VERSION = 1;

/**
 * Robust IndexedDB storage for large state objects (Gap 8 relief).
 */
export const MonyawnStorage = {
  db: null as IDBDatabase | null,

  async init(): Promise<IDBDatabase> {
    if (this.db) return this.db;

    return new Promise((resolve, reject) => {
      const request = indexedDB.open(DB_NAME, DB_VERSION);

      request.onupgradeneeded = (event: any) => {
        const db = event.target.result;
        if (!db.objectStoreNames.contains(STORE_NAME)) {
          db.createObjectStore(STORE_NAME);
        }
      };

      request.onsuccess = (event: any) => {
        this.db = event.target.result;
        resolve(this.db!);
      };

      request.onerror = (event: any) => {
        reject(event.target.error);
      };
    });
  },

  async saveState(state: AppState): Promise<void> {
    const db = await this.init();
    return new Promise((resolve, reject) => {
      const transaction = db.transaction(STORE_NAME, "readwrite");
      const store = transaction.objectStore(STORE_NAME);
      const request = store.put(state, "current-state");

      request.onsuccess = () => resolve();
      request.onerror = (event: any) => reject(event.target.error);
    });
  },

  async loadState(): Promise<AppState | null> {
    const db = await this.init();
    return new Promise((resolve, reject) => {
      const transaction = db.transaction(STORE_NAME, "readonly");
      const store = transaction.objectStore(STORE_NAME);
      const request = store.get("current-state");

      request.onsuccess = (event: any) => resolve(event.target.result || null);
      request.onerror = (event: any) => reject(event.target.error);
    });
  },

  async clearState(): Promise<void> {
    const db = await this.init();
    return new Promise((resolve, reject) => {
      const transaction = db.transaction(STORE_NAME, "readwrite");
      const store = transaction.objectStore(STORE_NAME);
      const request = store.delete("current-state");

      request.onsuccess = () => resolve();
      request.onerror = (event: any) => reject(event.target.error);
    });
  },
};
